'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { OnchainKitProvider } from '@coinbase/onchainkit';
import { base } from 'viem/chains';
export function OnchainKitWrapper(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      appearance: {
        name: "Wafra Money",
        logo: "/assets/logo.svg",
        mode: "auto",
        theme: "default"
      },
      wallet: {
        display: "modal",
        termsUrl: "/terms",
        privacyUrl: "/privacy"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <OnchainKitProvider chain={base} config={t1} apiKey={process.env.NEXT_PUBLIC_COINBASE_API_KEY} projectId={process.env.NEXT_PUBLIC_COINBASE_PROJECT_ID}>{children}</OnchainKitProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}